import type { Movie } from "@/mocks/catalog";

type CompactMovieProps = {
  movie: Movie;
};

export default function CompactMovie({ movie }: CompactMovieProps) {
  return (
    <article className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-300">
      <div className="h-24 w-16 flex-none overflow-hidden rounded-md bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.genre}海报`}
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <div className="flex items-center gap-2">
          <h3 className="font-heading text-base font-semibold text-foreground-950">
            {movie.title}
          </h3>
          <span className="flex items-center gap-0.5 text-xs font-medium text-accent-600">
            <i className="ri-star-fill"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <p className="text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <p className="mt-auto truncate text-xs text-foreground-500">主演 {movie.cast}</p>
      </div>
    </article>
  );
}